import * as React from "react";
import {
  container,
  paragraphContainerAlt,
} from "./ParagraphLayout.module.scss";
import { alt } from "../../../styles/global.module.scss";
export const Container: React.FC<any> = (props) => {
  return <div className={container}>{props.children}</div>;
};
export const ParagraphContainer: React.FC<any> = (props) => {
  //const _children = {...props.children, bgColor: props.bgColor};
  let cssClass = "";
  if (props.bgColor === "alt") {
    cssClass = alt;
  }
  return (
    <div className={cssClass}>
      {React.cloneElement(props.children, {
        bgColor: props.bgColor,
        isbelowSearchParagraphs: props.isbelowSearchParagraphs,
      })}
    </div>
  );
};
export const ParagraphContainerAlt: React.FC<any> = (props) => {
  return <div className={paragraphContainerAlt}>{props.children}</div>;
};
